import React from 'react';
import ChatUnreadBadge from './ChatUnreadBadge';

interface ChatUnreadNavBadgeProps {
  count: number;
}

const ChatUnreadNavBadge: React.FC<ChatUnreadNavBadgeProps> = ({ count }) => (
  <ChatUnreadBadge count={count} size="nav" />
);

export default ChatUnreadNavBadge;
